(function () {
  const toggle = document.querySelector("[data-menu-toggle]");
  const panel = document.querySelector("[data-mobile-panel]");
  if (!toggle || !panel) return;
  toggle.addEventListener("click", function () {
    const open = panel.classList.toggle("is-open");
    panel.hidden = !open;
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
  });
})();
